module.exports = __webpack_public_path__ + "img/media2.a4d2be3b.png";